import { useContext, createContext, useMemo } from 'react';
import { useOrderStatuses as useOrderStatusesHook } from '../hooks/useOrderStatuses';

const OrderStatusesContext = createContext([]);

export function OrderStatusesProvider({ children }) {
	const orderStatuses = useOrderStatusesHook();

	return (
		<OrderStatusesContext.Provider value={orderStatuses}>
			{children}
		</OrderStatusesContext.Provider>
	);
}

export const useOrderStatuses = () => useContext(OrderStatusesContext);

export function useOrderStatusOptions() {
	const orderStatuses = useOrderStatuses();
	return useMemo(
		() =>
			orderStatuses.map((status) => ({
				value: status.id,
				content: status.custom_label,
			})),
		[orderStatuses],
	);
}

export function useOrderStatusMap() {
	const orderStatuses = useOrderStatuses();
	return useMemo(
		() =>
			new Map(
				orderStatuses.map(({ id, custom_label }) => [id, custom_label]),
			),
		[orderStatuses],
	);
}
